<div class="row">
  <div class="col-12 padding-40">
    <div class="card-blueGDPR-container">

      <div *ngIf="firstLoading; else afterResponse" class="empty-data">
        <app-loader *ngIf="firstLoading" [label]="label"></app-loader>
      </div>

      <ng-template #afterResponse>
        <h2>{{documents.stats.filesAmount}} <span *ngIf="documents.stats.filesAmount==1">file</span><span *ngIf="documents.stats.filesAmount!=1">files</span>, {{ documents.stats.size | fileSize }}</h2>
<!--        <app-filter-files (selectedType)="selectType($event)" [browseDocumentTypes]="browseDocumentsType"></app-filter-files>-->

        <div *ngIf="documents == undefined || documents.stats.filesAmount == 0 || loading; else notEmptyDocuments" class="empty-data">
          <div *ngIf="(documents == undefined || documents.stats.filesAmount == 0) && !loading">No files :(</div>
        </div>

        <ng-template #notEmptyDocuments>
          <div class="select-row">
            <div class="sub-row row-bellow">
              <app-multiple-selection-baner [currentlySelected]="currentlySelected" [isAllSelected]="isAllSelected" [canBeDownload]="canBeDownload" (onAction)="handleAction($event)"></app-multiple-selection-baner>
            </div>
          </div>

          <div class="files-row" @list>
            <span *ngFor="let d of documents.documents | filter : selectedType : 'type'" @item>
              <app-dicom-file-item *ngIf="d.type=='dicom'" [document]="d" (deleteDocument)="deleteItem($event)" (downloadDocument)="downloadService($event)" (shareDocument)="openShareDialogForOneDocument($event)"></app-dicom-file-item>
            </span>
          </div>

        </ng-template>
      </ng-template>
    </div>
  </div>
</div>
